import { useLanguage } from '@hooks/useLanguage';
import { Customer } from '@widgets/cabinet/applicationCard/types';
import { useTranslation } from 'react-i18next';

export function useCustomerDescription(customer: Customer) {
  const language = useLanguage();
  const { t } = useTranslation();
  const { description, interDescription } = customer;
  const hasDataDescription = Boolean(description || interDescription);

  if (hasDataDescription) {
    return language === 'uk' ? description : interDescription;
  }
  return t('no-description');
}
